import { Link, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { Logo } from "../../QuoteCard/Logo";
import type { PartialQuotesReferralProps } from "../../types";

type Insurer = {
  insurerName: string;
  insurerLogo: string;
};

export function PartialQuotesReferral({
  quotes,
  customerName,
  coverOptionsUrl,
  view,
}: PartialQuotesReferralProps) {
  const insurersPanel: Insurer[] = (quotes || []).map(quote => ({
    insurerName: quote.insurerNameParametrized,
    insurerLogo: quote.insurerLogo,
  }));
  const { snowplow } = useSnowplowContext();
  const handleCoverOptionsClick = () =>
    snowplow?.trigger("referralReasonsVariantBCoverOptionsLinkClicked");

  return (
    <div
      data-testid={`partial-quotes-referral-${view}`}
      className={`partial-quotes-referral__container partial-quotes-referral__container--${view} partial-quotes-referral`}
    >
      <div className="partial-quotes-referral__main">
        <div className="partial-quotes-referral__info">
          <Text>
            Hi {customerName}, we&apos;ve searched through our panel of trusted
            providers but we havent been able to find many results that match
            your cover detail selections. You can expand your search by editing
            your choices on the{" "}
            <Link href={coverOptionsUrl} onClick={handleCoverOptionsClick}>
              Cover Options
            </Link>{" "}
            page or through the filters above.
          </Text>
        </div>
        <div className="partial-quotes-referral__insurer-panel">
          {insurersPanel.map((insurer, index) => (
            <Logo
              key={index}
              logoPath={insurer.insurerLogo}
              alt={insurer.insurerName}
              className="partial-quotes-referral-logo"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
